import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { StoreBarcode } from "tendercuts/models/barcode-display";

@Injectable({
  providedIn: "root",
})
export class FetchBarcodeService extends BaseGetProvider<StoreBarcode> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof StoreBarcode {
    return StoreBarcode;
  }

  get endpoint(): string {
    return this.endpointService.barcodeSpecEndpoint();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    entityId: string,
  ): {
    entity_id: string;
  } {
    const params: {
      entity_id: string;
    } = {
      entity_id: entityId,
    };

    return params;
  }
}
